import { AxiosRequestConfig } from 'axios';

import store from '@/store/store';
import { RootMutations } from '@/store/types/mutation-types';
import { combineSignals } from '@/bundles/Http/utils/combineSignals';

export function requestInterceptor (config: AxiosRequestConfig): AxiosRequestConfig {
  const token = store.state.idToken || store.state.temporaryAuthToken;
  if (token) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${ token }`,
    };
  }
  if (store.state.visitorId) {
    config.headers = {
      ...config.headers,
      'visitor-id': store.state.visitorId!,
    };
  }
  if (config.method?.toLowerCase() === 'get') {
    const controller = new AbortController();
    const persistOnRouteChange = (config as any).options?.persistOnRouteChange || false;

    store.commit(RootMutations.ADD_CANCEL_TOKEN, {
      controller,
      persistOnRouteChange,
    });

    config.signal = config.signal
      ? combineSignals([config.signal, controller.signal])
      : controller.signal;
  }
  return config;
}
